"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castel-morrone": {
    "5f958b5a": [{
      "hkey": "d616b1d2",
      "slug": "castel-morrone",
      "name": "Castel Morrone",
      "primary": true,
      "skipSearch": false
    }],
    "annunziata": [{
      "hkey": "d616b1d2",
      "slug": "castel-morrone",
      "name": "Castel Morrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "92a77e69": [{
      "hkey": "d616b1d2",
      "slug": "castel-morrone",
      "name": "Castel Morrone",
      "primary": true,
      "skipSearch": false
    }],
    "balzi": [{
      "hkey": "d616b1d2",
      "slug": "castel-morrone",
      "name": "Castel Morrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "00292abe": [{
      "hkey": "d616b1d2",
      "slug": "castel-morrone",
      "name": "Castel Morrone",
      "primary": true,
      "skipSearch": false
    }],
    "casale": [{
      "hkey": "d616b1d2",
      "slug": "castel-morrone",
      "name": "Castel Morrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1c69a31b": [{
      "hkey": "d616b1d2",
      "slug": "castel-morrone",
      "name": "Castel Morrone",
      "primary": true,
      "skipSearch": false
    }],
    "finestre": [{
      "hkey": "d616b1d2",
      "slug": "castel-morrone",
      "name": "Castel Morrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "12c626af": [{
      "hkey": "d616b1d2",
      "slug": "castel-morrone",
      "name": "Castel Morrone",
      "primary": true,
      "skipSearch": false
    }],
    "gradillo": [{
      "hkey": "d616b1d2",
      "slug": "castel-morrone",
      "name": "Castel Morrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ff1722cb": [{
      "hkey": "d616b1d2",
      "slug": "castel-morrone",
      "name": "Castel Morrone",
      "primary": true,
      "skipSearch": false
    }],
    "grottole": [{
      "hkey": "d616b1d2",
      "slug": "castel-morrone",
      "name": "Castel Morrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "647a7c82": [{
      "hkey": "d616b1d2",
      "slug": "castel-morrone",
      "name": "Castel Morrone",
      "primary": true,
      "skipSearch": false
    }],
    "largisi": [{
      "hkey": "d616b1d2",
      "slug": "castel-morrone",
      "name": "Castel Morrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1443d915": [{
      "hkey": "d616b1d2",
      "slug": "castel-morrone",
      "name": "Castel Morrone",
      "primary": true,
      "skipSearch": false
    }],
    "pianelli": [{
      "hkey": "d616b1d2",
      "slug": "castel-morrone",
      "name": "Castel Morrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dad4699c": [{
      "hkey": "d616b1d2",
      "slug": "castel-morrone",
      "name": "Castel Morrone",
      "primary": true,
      "skipSearch": false
    }],
    "sant-andrea": [{
      "hkey": "d616b1d2",
      "slug": "castel-morrone",
      "name": "Castel Morrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eb65021c": [{
      "hkey": "d616b1d2",
      "slug": "castel-morrone",
      "name": "Castel Morrone",
      "primary": true,
      "skipSearch": false
    }],
    "sopra-monte-scese-lunghe": [{
      "hkey": "d616b1d2",
      "slug": "castel-morrone",
      "name": "Castel Morrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "71f12e76": [{
      "hkey": "d616b1d2",
      "slug": "castel-morrone",
      "name": "Castel Morrone",
      "primary": true,
      "skipSearch": false
    }],
    "torone": [{
      "hkey": "d616b1d2",
      "slug": "castel-morrone",
      "name": "Castel Morrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;